import { CTA } from "components";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { CTASAdapterProps } from "./CTA.d";

const CTASAdapter = ({
  blok: {
    heading,
    buttonText,
    checkmarks,
    link: { url },
    gtmSection,
    gtmElement,
  },
}: ReactStoryblokComponent<CTASAdapterProps>) => {
  const checkboxes = checkmarks.length > 0 ? checkmarks.map(({ text }) => text) : undefined;

  return (
    <CTA
      text={heading}
      buttonText={buttonText}
      checkboxes={checkboxes}
      buttonHref={url}
      gtmSection={gtmSection}
      gtmElement={gtmElement}
    />
  );
};

export default CTASAdapter;
